module.exports = __webpack_public_path__ + "static/img/no-history.95ce4b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layout/pages/home/images/no-history.svg
// module id = YSrq
// module chunks = 7